import { defineComponent as _defineComponent } from 'vue'

import { ref, withDefaults, watch, computed, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return " Page was not found "
}
}

})